import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { queryClient } from "./shared/api/queryClient";

import { AuthProvider } from "./context/AuthContext";
import { RealtimeProvider } from "./context/RealtimeContext";
import { ThemeProvider } from "./context/ThemeContext";
import { ChatProvider } from "./context/ChatContext";
import { DashboardProvider } from "./context/DashboardContext";

// ✅ Modular Data Contexts (new structure)

import "bootstrap/dist/css/bootstrap.min.css";

// ===== Create root container =====
const container = document.getElementById("root");
const root = createRoot(container);

// ===== Render App with Contexts =====
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ThemeProvider>
          <RealtimeProvider>
            <DashboardProvider>
              <ChatProvider>
                <App />
              </ChatProvider>
            </DashboardProvider>
          </RealtimeProvider>
        </ThemeProvider>
      </AuthProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);

// ===== Optional Performance Logging =====
reportWebVitals();
